export default "__VITE_ASSET__m0B$PDRs__"